<mat-form-field appearance="outline" class="search-box">
  <mat-label>Search Stores</mat-label>
  <input matInput [(ngModel)]="searchText" placeholder="Type to search">
</mat-form-field>

<mat-selection-list #storeList>
  @for (store of filteredStores(); track store) {
    <mat-list-option
      [value]="store">
      {{ store.StoreName }}
    </mat-list-option>
  }
</mat-selection-list>

<div class="dialog-actions">
  <button mat-raised-button color="primary"
    [disabled]="!hasSelection()"
    (click)="submitSelection()">
    Add Selected
  </button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>
